import { render, staticRenderFns } from "./fileSelector.vue?vue&type=template&id=5a100ad6&scoped=true&"
import script from "./fileSelector.vue?vue&type=script&lang=js&"
export * from "./fileSelector.vue?vue&type=script&lang=js&"
import style0 from "./fileSelector.vue?vue&type=style&index=0&id=5a100ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a100ad6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VIcon,VRow,VSheet})
